import { ConfigurationStateInterface } from './configuration.types';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const configurationInitialState: ConfigurationStateInterface = {} as ConfigurationStateInterface;
